import React from "react";
import { GroupsPermissionsTabV2 } from "./GroupsPermissionsTabV2";
import { Shield } from "lucide-react";
import { Breadcrumb } from "../Breadcrumb";
import { TooltipProvider } from "../ui/tooltip";

interface AccessControlCenterProps {}

export function AccessControlCenter({}: AccessControlCenterProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-[1600px] mx-auto space-y-6">
          {/* Page Header */}
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white flex items-center gap-3">
                <div className="p-2 rounded-xl bg-primary/10">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                Access Control Center
              </h1>

              <Breadcrumb items={[{ label: "Access Control" }]} className="mt-2" />
            </div>
          </div>

          {/* Direct Content — Display Groups & Permissions */}
          <div className="mt-6">
            <GroupsPermissionsTabV2 />
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}